import { Component } from '@angular/core';

/** Coquille hôte : barre de titre (vente) + liste produits bibliothèque. */
@Component({
  selector: 'app-products-list-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class ProductsListShellComponent {}
